import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client'
import { onError } from '@apollo/client/link/error'
import readCsrfToken from 'util/readCsrfToken'

const httpLink = (uri: string) => {
  return new HttpLink({
    uri: uri,
    headers: {
      'X-CSRF-Token': readCsrfToken(),
    },
  })
}

const errorLink = onError(({ networkError }) => {
  if (networkError) {
    if ('statusCode' in networkError && networkError.statusCode === 401) {
      // User not authenticated. Reload the page to handle logout.
      window.location.reload()
    }
  }
})

const cache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        pagedReports: {
          // Don't cache separate results based on
          // any of this field's arguments.
          keyArgs: [],

          // Concatenate the incoming list items with
          // the existing list items.
          merge(existing = [], incoming, { args }) {
            // Slicing is necessary because the existing data is
            // immutable, and frozen in development.
            const merged = existing ? existing.slice(0) : []
            const offset = args ? (args.page - 1) * args.perPage : 1
            for (let i = 0; i < incoming.length; ++i) {
              merged[offset + i] = incoming[i]
            }

            return merged
          },
        },
      },
    },
  },
})

export const graphqlClient = (uri: string = '/graphql') => {
  return new ApolloClient({
    cache: cache,
    link: errorLink.concat(httpLink(uri)),
  })
}
